<template>
  <div class="cardList">
    <div class="content">
      <div class="list" >
        <div v-for="(item, index) in list" :key="index" class="li" >
          <div class="title">{{ index + 1| toChinesNum }}、{{  quesMap[item.trealType]}}</div>
          <!-- 套题 -->
          <div v-if="item.type == 'TT'"></div>
          <!-- 其他 -->
          <div class="d-flex d-flex-middle d-flex-wrap flex-wrap" v-else>
            <div
              v-for="(v, i) in item.questions"
              :key="'i' + i"
            >
              <div
                class="div click cp"
                :class="{ on: answers&&haveValue(answers['Q-'+v.id]) }"
                :style="{ marginRight: (i + 1) % 5 === 0 ? 0 : '23px' }"
                v-if="v.type == 'BLANKFILL'"
              >
                <span @click="toNext(v.id)" v-if="lastNext">{{ i + 1 }}</span>
                <a :href="toUrl(v.id)" v-else >{{ i + 1 }}</a>
              </div>
              <div
                v-else
                class="div click cp"
                :class="{ on: answers['Q-'+v.id] }"
                :style="{ marginRight: (i + 1) % 5 === 0 ? 0 : '23px' }"
              >
              <span @click="toNext(v.id)" v-if="lastNext">{{ i + 1 }}</span>
              <a :href="toUrl(v.id)" v-else >{{ i + 1 }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap } from "@/utils/enum.js";
export default {
  name: "cardList",
  props: {
    list: "",
    readOnly: false,
    answers: {},
    info: {},
    lastNext: {},
  },
  data() {
    return {
      quesMap,
      autoSave: null,
      autoSaveTime: 0,
    };
  },
  mounted() {
    // if (
    //   this.info.examResidueTime &&
    //   this.info.examResidueTime > 0 &&
    //   this.info.paper.category == "EXAMINE"
    // ) {
    //   if (this.autoSave) {
    //     this.clearOut();
    //   }
    //   this.setSt(this.info.examResidueTime);
    // }
  },
  computed: {
    total() {
      let num = 0
      this.list.map(item => {
        console.log(item.questions.length);
        
        num += item.questions.length
      })
      return num
    },
    conversionTime() {
      let s = this.autoSaveTime;
      // s 为传入方法的秒数s
      let m = Math.floor(s / 60);
      //计算秒
      //算法：取得秒%60的余数，既得到秒数
      s = s % 60;
      //将变量转换为字符串
      m += "";
      s += "";
      //如果只有一位数，前面增加一个0
      m = m.length == 1 ? "0" + m : m;
      s = s.length == 1 ? "0" + s : s;
      return (m != "00" ? m + "分钟" : "") + s + "秒";
    },
  },
  destroyed() {
    clearInterval(this.autoSave);
  },
  methods: {
    clearOut() {
      clearInterval(this.autoSave);
      this.autoSave = null;
    },
    setSt(t) {
      this.autoSaveTime = +t || 0;
      this.autoSave = setInterval(() => {
        if (this.autoSaveTime > 0) {
          this.autoSaveTime = this.autoSaveTime - 1;
        } else {
          this.clearOut();
          this.$emit("submit");
        }
      }, 1000);
    },
    haveValue(arr = "") {
      if (arr.indexOf("`") != -1) {
        return arr.split("`").some((v) => v != "");
      } else {
        return !!arr;
      }
      // return arr.some(v=>v.value != '')
    },
    close() {
      this.$emit("close");
    },
    
    submit() {
      this.$emit("submit");
    },
    
    upload() {},
    reform() {
      this.$emit("reform");
    },
    toUrl(m) {
      return "#" + "IdDiv" + m;
    },
    toNext(id){
      this.$emit('toNext',id)
    }
  },
};
</script>

<style lang="scss">
.cardList {
  // overflow-y: hidden;
  // height: 100%;
  
  .header {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    background: #DDE9FF;
    border-radius: 5px 5px 0px 0px;
    font-size: 16px;
    color: #1E6FFF;

    .submit {
      background: #1E6FFF;
      border-radius: 6px 6px 6px 6px;
      padding: 2px 6px;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
    }
  }

  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 15px 20px 15px 20px;
    position: relative;

    min-height: 200px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
   
    // overflow-y: hidden;
    // height: 100%;
    .list {
      
      .title {
        position: relative;
        padding-left: 13px;
        font-size: 16px;
        color: #333333;
        margin: 15px 0 20px 0;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 15px;
          background: #DC2815;
        }
      }
      .div {
        display: inline-block;
        width: 38px;
        height: 38px;
        background-color: #ECECEC;
        text-align: center;
        line-height: 38px;
        margin: 0 23px 15px 0;
        border-radius: 50%;
        font-size: 16px;
        color: #333333;
        &.on {
          background-color: #FFF4E8;
          color: #FBAD51;
        }
      }
    }
  }
  .btns {
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    .uploadBtn {
      margin-left: 15px;
    }
  }
}
.cp {
  cursor: pointer;
}
a {
  color: inherit;
  text-decoration: none;
  outline: none;
}
</style>
